import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  KC_LANES,
  KC_PRODUCT_LINES,
  KcLane,
  KcProductLine,
  kcContentCardClasses,
  kcPillClasses,
} from './kc-content-card.classes';

/**
 * A browse-lane content card (title + description + product-line pill + lane icon slot).
 *
 * Feature-local copy of the former `@pitchin/ui` `pin-kc-content-card` (ADR-0006). Projects an
 * icon into the `[kc-icon]` slot.
 */
@Component({
  selector: 'kc-content-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="kcard tw-bg-white tw-border tw-border-[#e7e7e7] tw-rounded-[12px] tw-p-[18px] tw-cursor-pointer tw-flex tw-flex-col tw-gap-2 tw-transition-shadow tw-duration-150 hover:tw-shadow-[0px_4px_32px_0px_#00000029] hover:tw--translate-y-0.5">
      <div [class]="iconClasses">
        <ng-content select="[kc-icon]"></ng-content>
      </div>
      <h4 class="tw-m-0 tw-text-[15.5px] tw-text-[#2a2a2a] tw-font-semibold">{{ title }}</h4>
      <p class="tw-m-0 tw-text-[#6a6a6a] tw-text-[13px] tw-leading-[1.5]">{{ description }}</p>
      <div class="kc-meta tw-flex tw-gap-[7px] tw-items-center tw-mt-1 tw-flex-wrap">
        <span *ngIf="productLine" [class]="pillClass">{{ productLineLabel }}</span>
        <span *ngIf="articleCount != null" class="kc-count tw-text-[11.5px] tw-text-[#9a9fa6] tw-font-medium">{{ articleCount }} articles</span>
      </div>
    </div>
  `,
})
export class KcContentCardComponent {
  static readonly lanes = KC_LANES;
  static readonly productLines = KC_PRODUCT_LINES;

  @Input() title = '';
  @Input() description = '';
  @Input() lane: KcLane = 'learn';
  @Input() productLine?: KcProductLine;
  @Input() articleCount?: number;

  get iconClasses(): string {
    return kcContentCardClasses(this.lane);
  }

  get pillClass(): string {
    return this.productLine ? kcPillClasses(this.productLine) : '';
  }

  get productLineLabel(): string {
    const labels: Record<KcProductLine, string> = {
      ecf: 'ECF',
      pstx: 'PSTX',
      ieo: 'IEO',
      general: 'General',
    };
    return this.productLine ? labels[this.productLine] : '';
  }
}
